import { useNavigate } from 'react-router'
import { ApplicationRoutes } from '~/hooks/useRouting'
import { LoginBackground } from '~/pages/Login/LoginBackground'
import { LoginPrompt } from '~/pages/Login/LoginPrompt'
import { PbxPrompt } from '~/pages/Login/PbxPrompt'

export const LoginPage = () => {
  const navigate = useNavigate()

  const handleLoginSuccess = () => {
    navigate(ApplicationRoutes.SELECT_PBX)
  }

  return (
    <LoginBackground>
      <LoginPrompt onLoginSuccess={handleLoginSuccess} />
    </LoginBackground>
  )
}

export const SelectPbxPage = () => {
  const navigate = useNavigate()

  const handleBackButtonPressed = () => {
    navigate(ApplicationRoutes.LOGIN, {
      replace: true,
    })
  }

  return (
    <LoginBackground>
      <PbxPrompt onBackButtonPressed={handleBackButtonPressed} />
    </LoginBackground>
  )
}

export default LoginPage
